import type { ThemeDefinition } from 'vuetify'

const getValidThemeValue = (
	clientVal: string | null,
	fallbackVal: string | undefined
) =>
	clientVal !== null && clientVal !== undefined && clientVal !== ''
		? clientVal
		: fallbackVal !== undefined && fallbackVal !== ''
			? fallbackVal
			: (() => {
					throw new Error('No valid theme value provided')
				})()

/**
 * Mandanteneinstellungen <-> Vuetify-Farben. Eine vom Mandanten gesetzte Farbe
 * gewinnt immer; nur leere Felder (null oder "") fallen auf `fallback` zurueck,
 * die Markenpalette der Domain (AAR-2003). `fallback` ist Pflicht, damit nie
 * stillschweigend die falsche Marke greift.
 */
export const mapThemeColors = (
	clientThemeOrColors: Api.ClientSetting | Record<string, string>,
	fallback: ThemeDefinition,
	reverse: boolean = false
) => {
	if (!reverse) {
		// Map from clientTheme to colors
		const clientTheme = clientThemeOrColors as Api.ClientSetting
		return {
			background: getValidThemeValue(
				clientTheme?.bgcolor_f,
				fallback?.colors?.background
			),
			nav: getValidThemeValue(clientTheme?.bgcolor_t, fallback?.colors?.nav),
			primary: getValidThemeValue(
				clientTheme?.color_l,
				fallback?.colors?.primary
			),
			secondary: getValidThemeValue(
				clientTheme?.color_a,
				fallback?.colors?.secondary
			),
			table: getValidThemeValue(clientTheme?.color_z, fallback?.colors?.table),
			text: getValidThemeValue(clientTheme?.color_t, fallback?.colors?.text),
		}
	} else {
		// Map from colors to clientTheme
		const colors = clientThemeOrColors as Record<string, string>
		return {
			bgcolor_f: colors.background ?? fallback?.colors?.background,
			bgcolor_t: colors.nav ?? fallback?.colors?.nav,
			color_l: colors.primary ?? fallback?.colors?.primary,
			color_a: colors.secondary ?? fallback?.colors?.secondary,
			color_z: colors.table ?? fallback?.colors?.table,
			color_t: colors.text ?? fallback?.colors?.text,
		}
	}
}
